<template>
    <section id="opener" class="padded-content">
        <div class="row margin-top-small">
            <div class="portion whole">
                <div class="border-thick margin-bottom-small"></div>
    
                <h1 class="text-hue"><strong>FICTOAN Framework</strong><span class="text-white">*</span></h1>
                <p class="text-white text-small">*Fuck I Couldn’t Think Of A Name Framework</p>
                <h5>Mockups with markup &mdash; build and style interactive, responsive interfaces with just plain ol’ HTML.</h5>

                <div class="border-thin margin-top-small margin-bottom-tiny"></div>
    
                <h4 class="weight-400 margin-bottom-fixed text-slate-50">v2.24.1</h4>
    
                <h5 class="text-regular no-margin-bottom">
                    <span><code class="weight-600">npm install fictoan</code></span> / <a href="https://github.com/sujan-s/fictoan/archive/master.zip"
                        target="_blank">Download</a> / <router-link to="/start">Docs</router-link> / <a href="https://github.com/sujan-s/fictoan" target="_blank">Github</a></h5>
            </div>
        </div>
    
        <!--  USPs ==================================================== -->
        <div class="row">
            <div class="portion half margin-bottom-tiny">
                <div class="border-gray margin-bottom-tiny"></div>
                <h6 class="margin-bottom-fixed">It’s intuitive.</h6>
                <p>FICTOAN uses straight-forward and intuitive class names like <code>.horizontal-center-this</code>, <code>.no-padding-left</code>,
                    <code>.center-on-mobile</code> and so on. Simple to use, and easy to recollect.</p>
            </div>

            <div class="portion half margin-bottom-tiny">
                <div class="border-gray margin-bottom-tiny"></div>
                <h6 class="margin-bottom-fixed">It’s modular.</h6>
                <p>Styling elements is like a jigsaw puzzle— take a <code>.button</code>, simply add <code>.bg-red</code>,
                    <code>.shape-circular</code> and <code>.no-shadow</code> to get a red, round button without a shadow.
                    It’s like playing with Lego.</p>
            </div>

            <div class="portion half margin-bottom-tiny">
                <div class="border-gray margin-bottom-tiny"></div>
                <h6 class="margin-bottom-fixed">It’s responsive.</h6>
                <p>Change layouts across devices&mdash; <code>.one-fourth</code>, <code>.one-third-on-tab-ls</code>, <code>.six-eights-on-mobile</code>
                    and whatnot. Or use <code>.retain-layout-on-mobile</code> to turn off responsiveness completely.</p>
            </div>

            <div class="portion half margin-bottom-tiny">
                <div class="border-gray margin-bottom-tiny"></div>
                <div class="margin-bottom-tiny padding-top-fixed">
                    <h6 class="margin-bottom-fixed">It’s customisable.</h6>
                    <p>Different projects with different primary colours? No problem just change one global variable, and
                        you’re
                        done! Tons of configurations in a snap.</p>
                </div>
            </div>

            <div class="portion half margin-bottom-tiny">
                <div class="border-gray margin-bottom-tiny"></div>
                <div class="margin-bottom-tiny padding-top-fixed">
                    <h6 class="margin-bottom-fixed">It’s ready to go.</h6>
                    <p>It comes with a set of pre-defined elements that you can simply drop into your project. Cards,
                        sidebar menus,
                        modal windows and more.</p>
                </div>
            </div>

            <div class="portion half margin-bottom-tiny">
                <div class="border-gray margin-bottom-tiny"></div>
                <div class="margin-bottom-tiny padding-top-fixed">
                    <h6 class="margin-bottom-fixed">It’s open source.</h6>
                    <p>Just head to the <a href="https://github.com/sujan-s/fictoan" target="_blank">Github</a> page and
                        fork at
                        will. Not interested in writing code? Just add your feedback, and it might just make it to the next
                        feature
                        release!</p>
                </div>
            </div>
        </div>
    </section>
</template>

<script>
    export default {
        name: 'home',

        components: {
        }
    }
</script>